import { get } from 'lodash-es';

export const selectViewPagingStats = (state, props) => get(state, props.viewName);
